import tinycolor from 'tinycolor2'
import { listItemClasses } from '@mui/material/ListItem'
const primary = '#326D8C'
const secondary = '#F18700'
const warning = '#FFC260'
const success = '#3CD4A0'
const info = '#9013FE'
const danger = '#EB5757'

const backgroundRate = 50
const lightenRate = 7.5
const darkenRate = 15

export default {
  palette: {
    primary: {
      main: primary,
      light: tinycolor(primary).lighten(lightenRate).toHexString(),
      dark: tinycolor(primary).darken(darkenRate).toHexString(),
      background: tinycolor(primary).lighten(backgroundRate).toHexString(),
    },
    secondary: {
      main: secondary,
      light: tinycolor(secondary).lighten(lightenRate).toHexString(),
      dark: tinycolor(secondary).darken(darkenRate).toHexString(),
      contrastText: '#FFFFFF',
      background: tinycolor(secondary).lighten(backgroundRate).toHexString(),
    },
    warning: {
      main: warning,
      light: tinycolor(warning).lighten(lightenRate).toHexString(),
      dark: tinycolor(warning).darken(darkenRate).toHexString(),
      background: tinycolor(warning).lighten(backgroundRate).toHexString(),
    },
    success: {
      main: success,
      light: tinycolor(success).lighten(lightenRate).toHexString(),
      dark: tinycolor(success).darken(darkenRate).toHexString(),
      background: tinycolor(success).lighten(backgroundRate).toHexString(),
    },
    info: {
      main: info,
      light: tinycolor(info).lighten(lightenRate).toHexString(),
      dark: tinycolor(info).darken(darkenRate).toHexString(),
      background: tinycolor(info).lighten(backgroundRate).toHexString(),
    },
    danger: {
      main: danger,
      light: tinycolor(danger).lighten(lightenRate).toHexString(),
      dark: tinycolor(danger).darken(darkenRate).toHexString(),
      background: tinycolor(danger).lighten(backgroundRate).toHexString(),
    },
    text: {
      primary: '#4A4A4A',
      secondary: '#6E6E6E',
      hint: '#B9B9B9',
    },
    background: {
      default: '#F6F7FF',
      light: '#F4F6FE',
    },
    captGrey: {
      main: '#707182',
      light: '#E3E3EC',
      veryLight: '#F4F6FE',
    },
  },
  customShadows: {
    widget:
      '0px 3px 11px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A',
    widgetDark:
      '0px 3px 18px 0px #4558A3B3, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A',
    widgetWide:
      '0px 12px 33px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A',
  },
  overrides: {
    MuiBackdrop: {
      root: {
        backgroundColor: '#4A4A4A6A',
      },
    },
    MuiMenu: {
      paper: {
        boxShadow:
          '0px 3px 11px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A',
      },
    },
    MuiSelect: {
      icon: {
        color: '#B9B9B9',
      },
    },
    MuiListItem: {
      root: {
        [`& .${listItemClasses.selected}`]: {
          backgroundColor: '#F3F5FF !important',
          '&:focus': {
            backgroundColor: '#F3F5FF',
          },
        },
      },
      button: {
        '&:hover, &:focus': {
          backgroundColor: '#F3F5FF',
        },
      },
    },
    MuiTouchRipple: {
      child: {
        backgroundColor: 'white',
      },
    },
    MuiTableRow: {
      root: {
        height: 56,
      },
    },
    MuiTableCell: {
      root: {
        borderBottom: '1px solid rgba(224, 224, 224, .5)',
      },
      head: {
        fontSize: '0.95rem',
      },
      body: {
        fontSize: '0.95rem',
      },
    },
    MuiDropzoneArea: {
      icon: {
        width: 0,
        height: 0,
      },
      text: {
        paddingLeft: '20px',
        paddingRight: '20px',
      },
      textContainer: {
        height: '10px',
      },
    },
    MuiDropzonePreviewList: {
      root: {
        alignContent: 'center',
      },
      image: {
        height: '200px',
      },
      removeButton: {
        left: 0,
        top: '40%',
        position: 'absolute',
        margin: 'auto',
        display: 'block',
      },
    },
  },
}
